import { Avatar, AvatarProps, Tooltip } from '@mui/material';
import { getCountryEmoji, getCountryName } from '@razz-team/utils';

interface AvatarCountryProps extends AvatarProps {
  country: string;
}

export function AvatarCountry({ country, ...props }: AvatarCountryProps) {
  const name = getCountryName(country);
  const emoji = getCountryEmoji(country);

  return (
    <Tooltip title={name} placement="top" arrow>
      <Avatar alt={name} {...props} sx={{ background: 'none' }}>
        {emoji}
      </Avatar>
    </Tooltip>
  );
}
